import React from 'react';
import { Select, Space } from 'antd';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'app/pages/DiscountsList/actionTypes';
import { changeTypeFilter, changeSchoolFilter, changeSortOrder } from 'app/pages/DiscountsList/filterActions';
import { getTypeFilter, getSchoolFilter, getSortOrder, getAllSchools } from 'app/pages/DiscountsList/modules/DiscountItemsList';
import { School } from 'app/shared/model';

const DISCOUNT_TYPE_OPTIONS = [
    { value: 'SpecialOffer', label: 'Special Offer' },
    { value: 'MarketDiscount', label: 'Market Discount' },
    { value: 'Promo', label: 'Promotion Code' },
];

const SORT_OPTIONS = [
    { value: 'Alphabetical', label: 'Alphabetical' },
    { value: 'RecentlyAdded', label: 'Recently Added' },
    { value: 'RecentlyUpdated', label: 'Recently Updated' },
];

const schoolToFilterId = (school: School): string =>
    `School-${school.id}`;

interface StateProps {
    typeFilter: string[];
    schoolFilter: string[];
    sortOrder: string;
    allSchools: School[];
}

interface DispatchProps {
    onTypeFilterChange: (types: string[]) => void;
    onSchoolFilterChange: (schoolIds: string[]) => void;
    onSortOrderChange: (sortOrder: string) => void;
}

const DiscountFilters: React.FC<StateProps & DispatchProps> = ({
    typeFilter,
    schoolFilter,
    sortOrder,
    allSchools,
    onTypeFilterChange,
    onSchoolFilterChange,
    onSortOrderChange,
}) => {
    const schoolOptions = allSchools.map(s => ({
        value: schoolToFilterId(s),
        label: s.name,
    }));

    return (
        <Space wrap align="center">
            <Select
                placeholder="All Types"
                allowClear
                mode="multiple"
                value={typeFilter}
                onChange={onTypeFilterChange}
                style={{ minWidth: 180 }}
                options={DISCOUNT_TYPE_OPTIONS}
            />

            <Select
                placeholder="All Schools"
                allowClear
                mode="multiple"
                value={schoolFilter}
                onChange={onSchoolFilterChange}
                style={{ minWidth: 220 }}
                showSearch={{ optionFilterProp: 'label' }}
                options={schoolOptions}
            />

            <Select
                value={sortOrder}
                onChange={onSortOrderChange}
                style={{ minWidth: 180 }}
                options={SORT_OPTIONS}
            />
        </Space>
    );
};

const mapStateToProps = (state: any): StateProps => ({
    typeFilter: getTypeFilter(state),
    schoolFilter: getSchoolFilter(state),
    sortOrder: getSortOrder(state),
    allSchools: getAllSchools(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): DispatchProps => ({
    onTypeFilterChange: (types: string[]) => dispatch(changeTypeFilter(types)),
    onSchoolFilterChange: (schoolIds: string[]) => dispatch(changeSchoolFilter(schoolIds)),
    onSortOrderChange: (sortOrder: string) => dispatch(changeSortOrder(sortOrder)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountFilters);